import videojs from 'video.js';
const Button = videojs.getComponent('Button');

/**
 * Big Play Button
 */
class BigPlayButton extends Button {

    
    constructor(public player, options) {
      super(player, options);

      // this.player.addClass('vjs-custom-big-play-button');
      // this.player.addClass('videoPlay');
      // this.remov('videoPlay');
      console.log(options,'player**');
      
    }
    
      createEl(tag = 'button', props = {className:"vjs-control vjs-button custom-size"}, attributes = {}) {
      let el = super.createEl(tag, props, attributes);
      // const color = '#7717fd';
      const color = '#fff'
      el.innerHTML = `<svg viewBox="0 0 34 36" fill=${color ? color : "#4967EE"} stroke=${color ? color : "#4967EE"} xmlns="http://www.w3.org/2000/svg"><path d="M1 18v-7.12C1 2.053 7.267-1.573 14.92 2.853l6.16 3.574L27.24 10c7.653 4.427 7.653 11.653 0 16.08l-6.16 3.573-6.16 3.574C7.267 37.573 1 33.973 1 25.12V18Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`
      return el;
    }

    updateColor({color}){
      const currentBtn = this.player.el()?.getElementsByTagName("svg")
      if(currentBtn &&  currentBtn.length){
        currentBtn[0]?.setAttribute("fill", color)
        currentBtn[0]?.setAttribute("stroke", color)
      }
    }
  
    handleClick () {
      /* do something on click */
      this.player = this.player
      if (this.player.paused()) {
        console.log('play');
        super.hide()
        this.player.play()
      this.player.removeClass('custom-size');

      }else{
        console.log('pause');
        this.player.removeClass('custom-size')
        super.show()
        this.player.paused()
      }
  
      
  }

}

export  default BigPlayButton;